import { createAsyncThunk } from '@reduxjs/toolkit';
import getStateFromThunkAPI from '../helpers/getStateFromThunkAPI';
import { makeMatchEvent, postMatchEvent } from '../../match/thunks';
import MatchEvent from '../../../interfaces/matchEvent';
import { matchSliceActions } from '../../match/matchSlice';
import { MatchEventType } from '../../../enums/matchEventType';

const publishPenaltyOutcomeEvent = createAsyncThunk(
  'input/publishPenaltyOutcomeEvent',
  async (payload: any, thunkAPI) => {
    const { dispatch } = thunkAPI;
    const { matchState } = getStateFromThunkAPI(thunkAPI);
    const { match } = matchState;
    const activeMatchEvents = match.matchEvents.filter((matchEvent) => matchEvent.internal?.active);

    const penaltyMatchEvents = activeMatchEvents.filter((matchEvent) => {
      if (
        matchEvent.internal?.active &&
        (matchEvent.matchEventTypeId === MatchEventType.PENALTY ||
          matchEvent.matchEventTypeId === MatchEventType.PENALTIES_PENALTY)
      ) {
        return matchEvent;
      }
    });

    const makePayload = { matchEventTypeId: payload.matchEventTypeId, goalPenalty: true, sorting: undefined };
    if (payload.sorting) {
      makePayload.sorting = payload.sorting;
    }
    const makeResponse = await dispatch(makeMatchEvent(makePayload));
    const matchEvent = makeResponse.payload as MatchEvent;

    dispatch(matchSliceActions.addEvent(matchEvent));
    dispatch(
      matchSliceActions.setEventInternal({
        mainEvent: false,
        active: true,
        sorting: payload.sorting ?? penaltyMatchEvents[0].sorting,
        liveFeedSerialId: matchEvent.liveFeedSerialId,
      }),
    );

    if (payload.await) {
      await dispatch(postMatchEvent(matchEvent));
    } else {
      dispatch(postMatchEvent(matchEvent));
    }
    return matchEvent;
  },
);

export default publishPenaltyOutcomeEvent;
